var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/add-person",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,13 C13.859,13 17,16.14 17,20 C17,20.552 16.553,21 16,21 L16,21 L4,21 C3.447,21 3,20.552 3,20 C3,16.14 6.141,13 10,13 Z M10,3 C12.206,3 14,4.794 14,7 C14,9.206 12.206,11 10,11 C7.794,11 6,9.206 6,7 C6,4.794 7.794,3 10,3 Z M19,4 C19.55,4 20,4.45 20,5 L20,5 L20,6 L21,6 C21.55,6 22,6.45 22,7 C22,7.55 21.55,8 21,8 L21,8 L20,8 L20,9 C20,9.55 19.55,10 19,10 C18.45,10 18,9.55 18,9 L18,9 L18,8 L17,8 C16.45,8 16,7.55 16,7 C16,6.45 16.45,6 17,6 L17,6 L18,6 L18,5 C18,4.45 18.45,4 19,4 Z",
    id: "path-1",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.c57a720a.svg";
export { ForwardRef as ReactComponent };